export default class Overlay {
    constructor({
            triggersSelector,
            overlaySelector,
            closeSelector,
            activeClass = 'is-open',
            isNavigation = false
        }) {
        this.triggersSelector = triggersSelector;
        this.overlaySelector = overlaySelector;
        this.closeSelector = closeSelector;
        this.activeClass = activeClass;
        this.isNavigation = isNavigation;

        this.triggers = document.querySelectorAll(triggersSelector);
        this.overlays = document.querySelectorAll(overlaySelector);
        this.body = document.body;

        if (this.triggers.length === 0 || !overlaySelector) return;

        this.init();
    }

    init() {
        this.attachTriggerListeners();
        this.attachCloseListeners();
        this.attachEscapeListener();
    }

    isOpen(overlay) {
        return overlay.classList.contains(this.activeClass);
    }

    open(overlay, link = null) {
        if (this.isOpen(overlay) && !this.isNavigation) return;

        overlay.classList.add(this.activeClass);

        // focus the search input if present
        const searchField = overlay.querySelector('.js-search__input');
        if (searchField) {
            setTimeout(() => searchField.focus(), 200);
        }

        if (this.isNavigation && link) {
            // close open overlays on desktop navigation
            this.overlays.forEach(o => this.close(o));
            this.handleNavigation(link, overlay);
        }
    }

    close(overlay) {
        if (!this.isOpen(overlay)) return;
        if (this.isNavigation) {
            this.body.classList.remove('nav-open');
            this.body.classList.remove('no-scroll');
        }
        overlay.classList.remove(this.activeClass);
    }

    attachTriggerListeners() {
        // add trigger listeners
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (event) => {
                let targetOverlay;

                if (this.isNavigation) {
                    // desktop navigation
                    targetOverlay = trigger.closest('.js-nav-main__item')?.querySelector(this.overlaySelector);

                    // mobile offCanvas
                    if (!targetOverlay) {
                        targetOverlay = document.querySelector(this.overlaySelector);
                    }
                } else {
                    // regular overlays like search
                    targetOverlay = document.querySelector(this.overlaySelector);

                    // close the open menu on desktop first
                    const openOverlay = document.querySelector('.js-nav-main__overlay.is-open');
                    if (openOverlay) {
                        this.close(openOverlay);
                    }
                }

                if (targetOverlay) {
                    event.preventDefault();
                    this.open(targetOverlay, trigger);
                }
            });
        });
    }

    attachCloseListeners() {
        // add close button + outside click listeners
        this.overlays.forEach(overlay => {
            const closeBtn = overlay.querySelector(this.closeSelector);

            closeBtn?.addEventListener('click', (event) => {
                event.preventDefault();
                this.close(overlay);
            });

            overlay.addEventListener('click', (event) => {
                if (event.target === overlay) {
                    this.close(overlay);
                }
            });
        });
    }

    attachEscapeListener() {
        // global ESC handler
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.overlays.forEach(overlay => this.close(overlay));
            }
        });
    }

    handleNavigation(link, overlay) {
        const hasSubItemsMobile = overlay.querySelectorAll('.js-subnav__trigger').length > 0;

        // 1st level offCanvas
        overlay.classList.add(this.activeClass);

        if (hasSubItemsMobile) {
            // all triggers, menus and buttons inside 1st level of offCanvas
            const subNavTriggers = overlay.querySelectorAll('.js-subnav__trigger');
            const subMenus = overlay.querySelectorAll('.js-submenu__offcanvas');
            const backBtns = overlay.querySelectorAll('.js-subnav__back');
            const closeBtns = overlay.querySelectorAll('.js-subnav__btn--close');
            const navTeaser = overlay.querySelector('.js-menu__teaser');

            this.body.classList.add('no-scroll');

            // open 2nd level
            subNavTriggers.forEach(trigger => {
                trigger.addEventListener('click', (event) => {
                    const subMenu = trigger.nextElementSibling;
                    if (subMenu && subMenu.classList.contains('js-submenu__offcanvas')) {
                        event.preventDefault();
                        subMenu.classList.add(this.activeClass);
                        navTeaser.classList.add('is-hidden');
                    }
                });
            });

            // back to 1st level offCanvas
            backBtns.forEach(backBtn => {
                backBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    const subMenu = backBtn.closest('.js-submenu__offcanvas');
                    if (subMenu) {
                        subMenu.classList.remove(this.activeClass);
                        navTeaser.classList.remove('is-hidden');
                    }
                });
            });

            // close offCanvas
            closeBtns.forEach(closeBtn => {
                closeBtn.addEventListener('click', (event) => {
                    event.preventDefault();

                    subMenus.forEach(menu => menu.classList.remove(this.activeClass));
                    this.close(overlay);
                });
            });
        } else {
            this.body.classList.add('nav-open');
        }
    }
}